<div class="modal-header">
        <h4 class="modal-title fw-bold">
            <span *ngIf="locationId" jhiTranslate="crop-settings-manager.location.modal.edit.header"></span>
            <span *ngIf="!locationId" jhiTranslate="crop-settings-manager.location.modal.create.header"></span>
        </h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
                (click)="clear()">
        </button>
</div>
<div class="modal-body">
    <form name="form" #f="ngForm">
        <div class="mb-3 row required">
            <label for="locationName" class="col-sm-4 col-form-label fw-bold" jhiTranslate="crop-settings-manager.location.location-name">Location Name</label>
            <div class="col-sm-8">
                <input type="text" class="form-control" name="name" id="code" [(ngModel)]="locationRequest.name" #locationName="ngModel" jhi-forbiddenCharactersValidator [forbidden_chars]=FORBIDDEN_CHARACTERS [maxLength]="60" [required]="true"/>
                <small *ngIf="locationName.errors?.['forbiddenCharacters']" class="text-danger">{{ 'crop-settings-manager.location.modal.validation.forbidden.characters' | translate : { characters: "< > | ? /" } }}</small>
            </div>
        </div>
        <div class="mb-3 row required">
            <label for="locationAbbr" class="col-sm-4 col-form-label fw-bold" jhiTranslate="crop-settings-manager.location.location-abbr">Location Abbreviation</label>
            <div class="col-sm-8">
                <input type="text" class="form-control" name="abbreviation" id="name" [(ngModel)]="locationRequest.abbreviation" #locationAbbr="ngModel" jhi-forbiddenCharactersValidator [forbidden_chars]=FORBIDDEN_CHARACTERS [maxLength]="12" [required]="true"/>
				<small *ngIf="locationAbbr.errors?.['forbiddenCharacters']" class="text-danger">{{ 'crop-settings-manager.location.modal.validation.forbidden.characters' | translate : { characters: "< > | ? /" } }}</small>
            </div>
        </div>
        <div class="mb-3 row required">
            <label for="type" class="col-sm-4 col-form-label fw-bold" jhiTranslate="crop-settings-manager.location.location-type">Location Type</label>
            <div class="col-sm-8">
                <select class="form-select" name="locationType" [(ngModel)]="locationRequest.type" #type="ngModel" [required]="true">
                    <option *ngFor="let locationType of locationTypes" [value]="locationType.id">
                        <label>{{locationType.name}}</label>
                    </option>
                </select>
            </div>
        </div>
        <div class="mb-3 row required">
            <label for="parentLocId" class="col-sm-4 col-form-label fw-bold" jhiTranslate="crop-settings-manager.location.parent-location">Parent Location</label>
            <div class="col-sm-8">
                <jhi-locations-select
                    [(value)]="parentLocationId"
                    [showFilterOptions]="false"
                    [showCountryField]="true">
                </jhi-locations-select>
            </div>
        </div>
        <div class="mb-3 row" style="margin-bottom: 5px;">
            <label for="abbreviation" class="col-sm-4 control-label fw-bold" style="margin-right: 15px;"  jhiTranslate="crop-settings-manager.location.geographical-details">Geographical Details</label>
            <div class="col-sm-2">
                <input type="number" class="form-control add_right_margin-10" name="latitude" [(ngModel)]="locationRequest.latitude"/>
            </div>
            <div class="col-sm-2">
                <input type="number" class="form-control col-sm-2 add_right_margin-10" name="longitude" [(ngModel)]="locationRequest.longitude"/>
            </div>
            <div class="col-sm-2">
                <input type="number" class="form-control col-sm-2 add_right_margin-10" name="altitude" [(ngModel)]="locationRequest.altitude"/>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4" style="margin-right: 15px;"></div>
            <div class="col-sm-2" style="margin-right: 15px;"><em>{{"crop-settings-manager.location.latitude" | translate}}</em></div>
            <div class="col-sm-2" style="margin-right: 15px;"><em>{{"crop-settings-manager.location.longitude" | translate}}</em></div>
            <div class="col-sm-2"><em>{{"crop-settings-manager.location.altitude" | translate}}</em></div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="clear()">
        <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="cancel"></span>
    </button>
    <button (click)="save(f)" [disabled]="!isFormValid(f)" class="btn btn-primary">
        <span *ngIf="isLoading" class="throbber throbber-btn"></span>
        <span class="fa fa-save"></span>&nbsp;
        <span *ngIf="locationId" jhiTranslate="update"></span>
        <span *ngIf="!locationId" jhiTranslate="create"></span>
    </button>
</div>
